import { defineMessages } from 'react-intl';

export default defineMessages({
  language: 'Language',
  countryCode: 'Country',
  device: 'Device',
  webpageUrl: 'Webpage URL',
  regionId: 'Region',
  municipalityId: 'Municipality',
  grades: 'Ratings',
  npsScore: 'NPS',
  findScore: 'Find score',
  operatingSystem: 'OS version',
  operatingSystemName: 'OS',
  browser: 'Browser version',
  browserName: 'Browser',
  responses: 'Responses',
  views: 'Views',
  csiScore: 'CSI Summary',
  pageflow: 'Page flow',
  inactive: 'Inactive',
});
